module.exports = __webpack_public_path__ + "img/img24.97ae2bd3.png";